import {
  GET_EXCO_DOCUMENT,
  GET_EXCO_DOCUMENT_SUCCESS,
  GET_EXCO_DOCUMENT_FAIL,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAIL,
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAIL,
  DOWNLOAD_DOCUMENT,
  DOWNLOAD_SUCCESS,
  DOWNLOAD_FAIL,
  GET_PROVINSI,
  GET_PROVINSI_SUCCESS,
  GET_PROVINSI_FAIL,
  GET_KABKOT,
  GET_KABKOT_SUCCESS,
  GET_KABKOT_FAIL,
  GET_KECAMATAN,
  GET_KECAMATAN_SUCCESS,
  GET_KECAMATAN_FAIL,
  GET_KELURAHAN,
  GET_KELURAHAN_SUCCESS,
  GET_KELURAHAN_FAIL,
  GET_TINGKAT_EXCO,
  GET_TINGKAT_EXCO_SUCCESS,
  GET_TINGKAT_EXCO_FAIL,
  GET_JABATAN,
  GET_JABATAN_SUCCESS,
  GET_JABATAN_FAIL,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAIL,
  UPDATE_PHONENUMBER,
  UPDATE_PHONENUMBER_SUCCESS,
  UPDATE_PHONENUMBER_FAIL,
  GET_ANGGOTA,
  GET_ANGGOTA_SUCCESS,
  GET_ANGGOTA_FAIL,
  GET_BANK,
  GET_BANK_SUCCESS,
  GET_BANK_FAIL,
  UPLOAD_DOCUMENT_PENGURUS,
  UPLOAD_DOCUMENT_PENGURUS_SUCCESS,
  UPLOAD_DOCUMENT_PENGURUS_FAIL,
  DELETE_DOCUMENT_PENGURUS,
  DELETE_DOCUMENT_PENGURUS_SUCCESS,
  DELETE_DOCUMENT_PENGURUS_FAIL,
  DOWNLOAD_DOCUMENT_PENGURUS,
  DOWNLOAD_DOCUMENT_PENGURUS_SUCCESS,
  DOWNLOAD_DOCUMENT_PENGURUS_FAIL,
  DOWNLOAD_HISTORY_DOCUMENT,
  DOWNLOAD_HISTORY_DOCUMENT_SUCCESS,
  DOWNLOAD_HISTORY_DOCUMENT_FAIL,
  LIST_HISTORY_DOCUMENT,
  LIST_HISTORY_DOCUMENT_SUCCESS,
  LIST_HISTORY_DOCUMENT_FAIL,
  GET_CATATAN,
  GET_CATATAN_SUCCESS,
  GET_CATATAN_FAIL,
  GET_KOMISARIS_BASIS,
  GET_KOMISARIS_BASIS_SUCCESS,
  GET_KOMISARIS_BASIS_FAIL
} from "./actionTypes";
import { API } from "../../API/api";

// Get all document
export const getExcoDocument = (id) => (dispatch) => {
  dispatch({
    type: GET_EXCO_DOCUMENT,
  });

  const request = API.getExcoDocument(id);
  return request.then(
    (response) => dispatch(getExcoDocumentSuccess(response.data)),
    (err) => dispatch(getExcoDocumentFail(err))
  );
};

export const getExcoDocumentSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_DOCUMENT_SUCCESS,
    payload: data,
  });
};

export const getExcoDocumentFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_DOCUMENT_FAIL,
    payload: data,
  });
};

// upload document
export const uploadDocument = (payload) => (dispatch) => {
  dispatch({
    type: UPLOAD_DOCUMENT,
  });

  const request = API.uploadDocument(payload);
  return request.then(
    (response) => dispatch(uploadDocumenttSuccess(response.data)),
    (err) => dispatch(uploadDocumentFail(err))
  );
};

export const uploadDocumenttSuccess = (data) => (dispatch) => {
  return dispatch({
    type: UPLOAD_DOCUMENT_SUCCESS,
    payload: data,
  });
};

export const uploadDocumentFail = (data) => (dispatch) => {
  return dispatch({
    type: UPLOAD_DOCUMENT_FAIL,
    payload: data,
  });
};

// delete  document
export const deleteDocument = (payload) => (dispatch) => {
  dispatch({
    type: DELETE_DOCUMENT,
  });

  const request = API.deleteDocument(payload);
  return request.then(
    (response) => dispatch(deleteDocumentSuccess(response.data)),
    (err) => dispatch(deleteDocumentFail(err))
  );
};

export const deleteDocumentSuccess = (data) => (dispatch) => {
  return dispatch({
    type: DELETE_DOCUMENT_SUCCESS,
    payload: data,
  });
};

export const deleteDocumentFail = (data) => (dispatch) => {
  return dispatch({
    type: DELETE_DOCUMENT_FAIL,
    payload: data,
  });
};
// download  document
export const downloadDocument = (payload) => (dispatch) => {
  dispatch({
    type: DOWNLOAD_DOCUMENT,
  });

  const request = API.downloadDocument(payload);
  return request.then(
    (response) => dispatch(downloadDocumentSuccess(response.data)),
    (err) => dispatch(downloadDocumentFail(err))
  );
};

export const downloadDocumentSuccess = (data) => (dispatch) => {
  return dispatch({
    type: DOWNLOAD_SUCCESS,
    payload: data,
  });
};

export const downloadDocumentFail = (data) => (dispatch) => {
  return dispatch({
    type: DOWNLOAD_FAIL,
    payload: data,
  });
};

// liat history  document
export const listHistoryDocument = (id_kantor,id_kategori_dokumen) => (dispatch) => {
  dispatch({
    type: LIST_HISTORY_DOCUMENT,
  });

  const request = API.listHistoryDocument(id_kantor,id_kategori_dokumen);
  return request.then(
    (response) => dispatch(listHistoryDocumenttSuccess(response.data)),
    (err) => dispatch(dlistHistoryDocumentFail(err))
  );
};

export const listHistoryDocumenttSuccess = (data) => (dispatch) => {
  return dispatch({
    type: LIST_HISTORY_DOCUMENT_SUCCESS,
    payload: data,
  });
};

export const dlistHistoryDocumentFail = (data) => (dispatch) => {
  return dispatch({
    type: LIST_HISTORY_DOCUMENT_FAIL,
    payload: data,
  });
};

// download history document
export const downloadHistoryDocument = (payload) => (dispatch) => {
  dispatch({
    type: DOWNLOAD_HISTORY_DOCUMENT,
  });

  const request = API.downloadHistoryDocument(payload);
  return request.then(
    (response) => dispatch(downloadHistoryDocumentSuccess(response.data)),
    (err) => dispatch(downloadHistoryDocumentFail(err))
  );
};

export const downloadHistoryDocumentSuccess = (data) => (dispatch) => {
  return dispatch({
    type: DOWNLOAD_HISTORY_DOCUMENT_SUCCESS,
    payload: data,
  });
};

export const downloadHistoryDocumentFail = (data) => (dispatch) => {
  return dispatch({
    type: DOWNLOAD_HISTORY_DOCUMENT_FAIL,
    payload: data,
  });
};

// GET PROVINCE
export const getProvince = () => (dispatch) => {
  dispatch({
    type: GET_PROVINSI,
  });

  const request = API.getProvince();
  return request.then(
    (response) => dispatch(getProvinceSuccess(response.data)),
    (err) => dispatch(getProvinceFail(err))
  );
};

export const getProvinceSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_PROVINSI_SUCCESS,
    payload: data,
  });
};

export const getProvinceFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_PROVINSI_FAIL,
    payload: data,
  });
};

// GET KABKOT
export const getKabKot = (param) => (dispatch) => {
  dispatch({
    type: GET_KABKOT,
  });

  const request = API.getKabKot(param);
  return request.then(
    (response) => dispatch(getKabKotSuccess(response.data)),
    (err) => dispatch(getKabKotFail(err))
  );
};

export const getKabKotSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_KABKOT_SUCCESS,
    payload: data,
  });
};

export const getKabKotFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_KABKOT_FAIL,
    payload: data,
  });
};

// GET KECAMATAN
export const getKecamatan = (param) => (dispatch) => {
  dispatch({
    type: GET_KECAMATAN,
  });

  const request = API.getKecamatan(param);
  return request.then(
    (response) => dispatch(getKecamatanSuccess(response.data)),
    (err) => dispatch(getKecamatanFail(err))
  );
};

export const getKecamatanSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_KECAMATAN_SUCCESS,
    payload: data,
  });
};

export const getKecamatanFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_KECAMATAN_FAIL,
    payload: data,
  });
};

// GET kelurahan
export const getKelurahan = (param) => (dispatch) => {
  dispatch({
    type: GET_KELURAHAN,
  });

  const request = API.getKelurahan(param);
  return request.then(
    (response) => dispatch(getKelurahanSuccess(response.data)),
    (err) => dispatch(getKelurahanFail(err))
  );
};

export const getKelurahanSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_KELURAHAN_SUCCESS,
    payload: data,
  });
};

export const getKelurahanFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_KELURAHAN_FAIL,
    payload: data,
  });
};

// GET tingkatExco
export const getTingkatExco = () => (dispatch) => {
  dispatch({
    type: GET_TINGKAT_EXCO,
  });

  const request = API.getTingkatExco();
  return request.then(
    (response) => dispatch(getTingkatExcoSuccess(response.data)),
    (err) => dispatch(getTingkatExcoFail(err))
  );
};

export const getTingkatExcoSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_TINGKAT_EXCO_SUCCESS,
    payload: data,
  });
};

export const getTingkatExcoFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_TINGKAT_EXCO_FAIL,
    payload: data,
  });
};

// GET jabatan
export const getJabatan = (param) => (dispatch) => {
  dispatch({
    type: GET_JABATAN,
  });

  const request = API.getJabatan(param);
  return request.then(
    (response) => dispatch(getJabatanSuccess(response.data)),
    (err) => dispatch(getJabatanFail(err))
  );
};

export const getJabatanSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_JABATAN_SUCCESS,
    payload: data,
  });
};

export const getJabatanFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_JABATAN_FAIL,
    payload: data,
  });
};

// GET anggota
export const getAnggota = (search) => (dispatch) => {
  dispatch({
    type: GET_ANGGOTA,
  });

  const request = API.getAnggota(search);
  return request.then(
    (response) => dispatch(getAnggotaSuccess(response.data)),
    (err) => dispatch(getAnggotaFail(err))
  );
};

export const getAnggotaSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_ANGGOTA_SUCCESS,
    payload: data,
  });
};

export const getAnggotaFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_ANGGOTA_FAIL,
    payload: data,
  });
};

// GET profile
export const getProfile = () => (dispatch) => {
  dispatch({
    type: GET_PROFILE,
  });

  const request = API.getProfile();
  return request.then(
    (response) => dispatch(getProfileSuccess(response.data)),
    (err) => dispatch(getProfileFail(err))
  );
};

export const getProfileSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_PROFILE_SUCCESS,
    payload: data,
  });
};

export const getProfileFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_PROFILE_FAIL,
    payload: data,
  });
};

// change password
export const changePassword = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_PASSWORD,
  });

  const request = API.changePassword(data);
  return request.then(
    (response) => dispatch(changePasswordSuccess(response.data)),
    (err) => dispatch(changePasswordFail(err))
  );
};

export const changePasswordSuccess = (data) => (dispatch) => {
  return dispatch({
    type: UPDATE_PASSWORD_SUCCESS,
    payload: data,
  });
};

export const changePasswordFail = (data) => (dispatch) => {
  return dispatch({
    type: UPDATE_PASSWORD_FAIL,
    payload: data,
  });
};

// change phonenumber
export const changePhoneNumber = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_PHONENUMBER,
  });

  const request = API.changePhoneNumber(data);
  return request.then(
    (response) => dispatch(changePhoneNumberSuccess(response.data)),
    (err) => dispatch(changePhoneNumberFail(err))
  );
};

export const changePhoneNumberSuccess = (data) => (dispatch) => {
  return dispatch({
    type: UPDATE_PHONENUMBER_SUCCESS,
    payload: data,
  });
};

export const changePhoneNumberFail = (data) => (dispatch) => {
  return dispatch({
    type: UPDATE_PHONENUMBER_FAIL,
    payload: data,
  });
};

// GET bank
export const getBank = () => (dispatch) => {
  dispatch({
    type: GET_BANK,
  });

  const request = API.getBank();
  return request.then(
    (response) => dispatch(getBankSuccess(response.data)),
    (err) => dispatch(getBankFail(err))
  );
};

export const getBankSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_BANK_SUCCESS,
    payload: data,
  });
};

export const getBankFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_BANK_FAIL,
    payload: data,
  });
};

export const uploadDocumentPengurus = (payload) => (dispatch) => {
  dispatch({
    type: UPLOAD_DOCUMENT_PENGURUS,
  });

  const request = API.uploadDocumentPengurus(payload);
  return request.then(
    (response) => dispatch(global(response.data,UPLOAD_DOCUMENT_PENGURUS_SUCCESS)),
    (err) => dispatch(global(err,UPLOAD_DOCUMENT_PENGURUS_FAIL))
  );
};

// delete  document
export const deleteDocumentPengurus = (payload) => (dispatch) => {
  dispatch({
    type: DELETE_DOCUMENT_PENGURUS,
  });

  const request = API.deleteDocumentPengurus(payload);
  return request.then(
    (response) => dispatch(global(response.data,DELETE_DOCUMENT_PENGURUS_SUCCESS)),
    (err) => dispatch(global(err,DELETE_DOCUMENT_PENGURUS_FAIL))
  );
};
// download  document
export const downloadDocumentPengurus = (payload) => (dispatch) => {
  dispatch({
    type: DOWNLOAD_DOCUMENT_PENGURUS,
  });

  const request = API.downloadDocumentPengurus(payload);
  return request.then(
    (response) => dispatch(global(response.data,DOWNLOAD_DOCUMENT_PENGURUS_SUCCESS)),
    (err) => dispatch(global(err,DOWNLOAD_DOCUMENT_PENGURUS_FAIL))
  );
};

export const global = (data,action_type) => (dispatch) => {
  return dispatch({
    type: action_type,
    payload: data,
  });
};

// GET Catatan
export const getCatatan = () => (dispatch) => {
  dispatch({
    type: GET_CATATAN,
  });

  const request = API.getCatatan();
  return request.then(
    (response) => dispatch(getCatatanSuccess(response.data)),
    (err) => dispatch(getCatatanFail(err))
  );
};

export const getCatatanSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_CATATAN_SUCCESS,
    payload: data,
  });
};

export const getCatatanFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_CATATAN_FAIL,
    payload: data,
  });
};

// GET Komisaris Basis
export const getKomisarisBasis = () => (dispatch) => {
  dispatch({
    type: GET_KOMISARIS_BASIS,
  });

  const request = API.getKomisarisBasis();
  return request.then(
    (response) => dispatch(getKomisarisBasisSuccess(response.data)),
    (err) => dispatch(getKomisarisBasisFail(err))
  );
};

export const getKomisarisBasisSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_KOMISARIS_BASIS_SUCCESS,
    payload: data,
  });
};

export const getKomisarisBasisFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_KOMISARIS_BASIS_FAIL,
    payload: data,
  });
};
